import type { Theme } from '@mui/material';

export const styles = {
  link: (theme: Theme) => ({
    textDecoration: 'none',
    color: theme.colors.info[600],
    fontWeight: '600',
    fontSize: 14,
  }),
};
